<div class="mb-grid-col-4 mb-grid-col-12-tb mb-grid-col-12-dt total-price-container">

  <ng-container
    *ngIf="rate.status !== 'UNAVAILABLE' && !rate.error">

    <div (click)="checkRateBeforeAddToTrip($event, rate)" class="expert-add-product-wrapper" *ngIf="isExperts">
      <am-trips-add-product
        *ngIf="isExperts"
        [productType]="productType"
        [product]="tripFavoriteData"
        [currencyCode]="currencyCodeToTripFavorite"
      ></am-trips-add-product>
      <div class="shield"></div>
    </div>
    <ng-container *ngIf="isExperts; else notExpertsWithDiscount">
      <div class="provider-info-discount">
        <div
          class="provider-info-container"
          *ngIf="
          isExperts &&
          cluster?.rates &&
          (cluster?.rates)[0] &&
          (cluster?.rates)[0]?.provider
        "
        >
          <provider-info [cluster]="cluster" [isExperts]="isExperts"></provider-info>
        </div>
        <mb-advice
          align="right"
          color="success"
          *ngIf="rate.price.discount.percentage >= 5"
          class="gift"
        >
          {{ rate.price.discount.percentage | number: '1.0-0' }}% OFF
        </mb-advice>
      </div>
    </ng-container>
    <ng-template #notExpertsWithDiscount>
      <mb-advice
        align="right"
        color="success"
        *ngIf="rate.price.discount.percentage >= 5"
        class="gift"
      >
        {{ rate.price.discount.percentage | number: '1.0-0' }}% OFF
      </mb-advice>
    </ng-template>
  </ng-container>
  <am-price
    *ngIf="!isAlliance"
    [rateSelected]="rate$ | async"
    [showAmountTotal]="priceByValue === 'TOTAL'"
    [fop]="rate.payment_method.code"
    [isArgentinian]="isArgentinian"
  ></am-price>
  <button
    mb-button
    variant="principal"
    color="primary"
    [loading]="loadingRate === rate.id"
    [disabled]="rate.status === 'UNAVAILABLE' || rate.error"
    (click)="checkRate(rate)">
    {{ btnLabel }}
  </button>
  <am-experts-compensation
    [channel]="'web'"
    [margin]="showCommission(rate)"
    [productType]="'HOTEL'"
    [brand]="'almundo'"
    [currency]="rate.price.currency.code"
  >
  </am-experts-compensation>
</div>
